import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getPropertyNameInput = (searchCriteria: SearchCriteriaModel): string | null =>
  searchCriteria.hotelName ? searchCriteria.hotelName : null;
